/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChangeOrderTemplatesControllerUpdateMutationRequest, ChangeOrderTemplatesControllerUpdateMutationResponse, ChangeOrderTemplatesControllerUpdatePathParams, ChangeOrderTemplatesControllerUpdate400, ChangeOrderTemplatesControllerUpdate401, ChangeOrderTemplatesControllerUpdate403, ChangeOrderTemplatesControllerUpdate404 } from "../../models/changeOrderTemplatesController/ChangeOrderTemplatesControllerUpdate";

function getChangeOrderTemplatesControllerUpdateUrl(id: ChangeOrderTemplatesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/change-order-templates/${id}` as const }  
  return res
}

/**
 * @summary Point a change order template at a different project file
 * {@link /api/v1/change-order-templates/:id}
 */
export async function changeOrderTemplatesControllerUpdate(id: ChangeOrderTemplatesControllerUpdatePathParams["id"], data?: ChangeOrderTemplatesControllerUpdateMutationRequest, config: Partial<RequestConfig<ChangeOrderTemplatesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ChangeOrderTemplatesControllerUpdateMutationResponse, ResponseErrorConfig<ChangeOrderTemplatesControllerUpdate400 | ChangeOrderTemplatesControllerUpdate401 | ChangeOrderTemplatesControllerUpdate403 | ChangeOrderTemplatesControllerUpdate404>, ChangeOrderTemplatesControllerUpdateMutationRequest>({ method : "PATCH", url : getChangeOrderTemplatesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}